/** Inbox that receives pilot requests while no booking page is configured. */
export const BOOKING_FALLBACK_EMAIL = 'biteclub26@gmail.com';

/**
 * Link target for every booking CTA on the public site.
 *
 * Returns `NEXT_PUBLIC_BOOKING_URL` when it is set, otherwise a `mailto:` link to
 * the fallback inbox with the given subject. Next.js inlines the variable at build
 * time only for the literal `process.env.NEXT_PUBLIC_BOOKING_URL` expression, so a
 * changed value needs a redeploy.
 */
export function getBookingHref(mailSubject: string): string {
  const url = (process.env.NEXT_PUBLIC_BOOKING_URL ?? '').trim();
  return url || `mailto:${BOOKING_FALLBACK_EMAIL}?subject=${encodeURIComponent(mailSubject)}`;
}
